import{Temporal as o,Intl as t,toTemporalInstant as a}from"./impl.mjs";import"./common-a14efb97.mjs";const l=globalThis.Temporal,m=l||o,s=l?globalThis.Intl:t,p=l?globalThis.Date.prototype.toTemporalInstant:a;export{s as Intl,m as Temporal,p as toTemporalInstant};
//# sourceMappingURL=index.mjs.map
